import { Box, Divider, IconButton, styled, Typography } from '@mui/material';
import { IconCross, IconInbox, IconUser } from 'assets/img';
import { getFullNameWithInfix } from 'hq/components/views/flexWorkers/utils';
import { SignDocumentHeaderProps } from './sign-document-dialog-header.types';

export const SignDocumentDialogHeader = ({
  onClose,
  firstName,
  lastName,
  infix,
  email,
  documentName,
  documentType,
}: SignDocumentHeaderProps) => {
  return (
    <Box margin={'20px'}>
      <HeaderWrapper>
        <FlexColumnBoxCenter role="fw-profile">
          <Typography variant="h3" fontWeight={500} noWrap>
            {documentName}
          </Typography>
          <Typography variant="subtitle1" noWrap>
            {documentType}
          </Typography>
        </FlexColumnBoxCenter>

        <InfoWrap>
          <WorkerInfoWrap>
            <Box display="flex" flexDirection="row" gap="8px">
              <StyledIcon width={24} height={24} as={IconUser} />
              <CredentialText paddingRight={5} noWrap>
                {getFullNameWithInfix({ firstName, infix, lastName })}
              </CredentialText>
            </Box>
            <Box display="flex" flexDirection="row" gap="8px">
              <StyledIcon width={24} height={24} as={IconInbox} />
              <CredentialText paddingRight={5} noWrap>
                {email}
              </CredentialText>
            </Box>
            <Box display="flex" flexDirection="row">
              <IconButton onClick={onClose}>
                <IconCross width={24} height={24} />
              </IconButton>
            </Box>
          </WorkerInfoWrap>
        </InfoWrap>
      </HeaderWrapper>
      <Divider />
    </Box>
  );
};

const FlexColumnBoxCenter = styled(Box)(() => ({
  alignItems: 'flex-start',
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
}));

const WorkerInfoWrap = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '4px',
  alignItems: 'flex-end',
}));

const HeaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch',
  marginBottom: theme.spacing(3),
}));

const CredentialText = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  fontWeight: 500,
  marginLeft: theme.spacing(1),
  opacity: '0.6',
}));

const InfoWrap = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-end',
  gap: '24px',
  marginLeft: 'auto',
  cursor: 'default',
}));

const StyledIcon = styled('svg')(() => ({
  '& path': {
    stroke: 'rgba(0, 0, 0, 0.4)',
  },
}));
